import approvalService from "@services/approval/approvalService"
import fileService from "@services/common/fileService"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import { action, makeAutoObservable, observable } from "mobx"

class ApprovalStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any

  @observable tableUpdateRequestData!: PagedResultDto<any>
  @observable detailUpdateRequestData!: any
  @observable rejectReason!: any
  @observable approvalHistory!: any

  constructor() {
    makeAutoObservable(this)

    this.tableData = { items: [], totalCount: 0 }
    this.detailData = {}
    this.isLoading = false

    this.tableUpdateRequestData = { items: [], totalCount: 0 }
    this.detailUpdateRequestData = {}
    this.rejectReason = {}
    this.approvalHistory = {
      histories: [],
      requestConfiguration: {},
    }
  }

  @action
  async createOrUpdatePosition(body: any, deleteIds?) {
    await approvalService.CreateOrUpdatePosition(body)

    if (deleteIds && deleteIds.length > 0) {
      await approvalService.bulkDelete(deleteIds)
    }
  }

  @action
  async getConfig(id: number) {
    const result = await approvalService.getConfig(id)
    this.detailData = result
  }

  @action
  async getAllConfig(params: any) {
    this.isLoading = true
    const result = await approvalService
      .getAllConfig(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }
  @action
  async getRejectReason(params: any) {
    this.isLoading = true
    this.rejectReason = await approvalService
      .getRejectReason(params)
      .finally(() => (this.isLoading = false))
  }
  // Approval flow
  @action
  async updateRequestStatus(body: any, files?: any[], initUniqueId?, timeout?: number) {
    this.isLoading = true
    const result = await approvalService
      .updateRequestStatus(body, timeout)
      .finally(() => (this.isLoading = false))
    // approvalService trả về res.data (ABP wrapper), uniqueId nằm trong result.result
    const { uniqueId } = result?.result ?? {}
    const effectiveUniqueId = initUniqueId ?? uniqueId

    if (files && files.length && effectiveUniqueId) {
      const filesBody = {
        moduleName: "RequestFlow",
        uniqueId: effectiveUniqueId,
        descriptions: [...files].map((item) => item?.description),
      }

      await fileService.uploadDocumentWithModuleName(
        [...files].map((item) => item?.file),
        filesBody
      )
    } else if (files && files.length) {
      console.warn('[ApprovalStore] Files present but no uniqueId to upload against.', {
        filesCount: files.length,
        initUniqueId,
        uniqueIdFromResult: uniqueId,
      })
    }
  }

  // FOR CUSTOMER
  @action
  async getAllCustomerUpdateRequest(params: any) {
    this.isLoading = true
    const result = await approvalService
      .getAllCustomerUpdateRequest(params)
      .finally(() => (this.isLoading = false))
    this.tableUpdateRequestData = result
  }
  @action
  async getCustomerUpdateRequest(id: any) {
    this.isLoading = true
    const result = await approvalService
      .getCustomerUpdateRequest(id)
      .finally(() => (this.isLoading = false))
    this.detailUpdateRequestData = result
  }

  @action
  async getListApprovalHistory(params: any) {
    const result = await approvalService.getListApprovalHistory(params)
    this.approvalHistory = result
  }
}

export default ApprovalStore
